import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
// const YoungKorea = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/05. 영안모자 한국본사.jpg`;
import YoungKorea from "../../assets/KoreaCompany/영안모자 한국본사.png";
const YoungHistory = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/06. 영안역사기록실.143f4a1a50a07e11553d.jpg`;
const YounganMusium = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/07. 모자종합역사관.bca8e61b5fdd5c78ecfb.jpg`;
const HatImg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/08. 영안모자 한국본사 모자.308fa73a08d1288501b6.png`;
import HatPageTopLine from "../../Component/HatPageTopLine.js";
const KoreaCompany = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/KoreaCompany">
                <div className="kor">영안모자 한국본사</div>
                <div className="eng">Korean Headquarters</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"영안모자 한국본사"}
              titleeng={"Korean Headquarters of YoungAn Hat"}
              website="https://www.younganhat.com"
              isReady={false}
            />
            <div className="page-text">
              <div className="kor">
                <h2>YoungAn Hat Co., Ltd. / YoungAn International Co., Ltd.</h2>
              </div>
              <div className="eng">
                <h2>YoungAn Hat Co., Ltd. / YoungAn International Co., Ltd.</h2>
              </div>
            </div>

            <S.ImgHolderFullsize>
              <img src={YoungKorea} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">영안모자 한국 본사</div>
                <div className="eng">Korean Headquarters</div>
              </div>
            </S.ImgHolderFullsize>

            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={YoungHistory} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">영안 역사기록관</div>
                  <div className="eng">YoungAn History Hall</div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={YounganMusium} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">모자 종합역사관</div>
                  <div className="eng">YoungAn Hat History Hall</div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>

            <PageTitle titleko={"주요이력"} titleeng={"Major History"} />
            <div className="page-text">
              <div className="kor">
                <h2>영안모자점 창업 : 1959년</h2>
                <br />
                ※ 본사: 영안모자(주) / (주)영안양행
                <br />
                ※ 영안 모자사업의 지주회사이며, 모체회사
                <br />
                ※ 전 세계 모자사업을 관리, 조정하는 본부 역할 수행
                <br />
                ※ 글로벌 생산 및 판매 네트워크 : 7개국 / 12개 법인
                <br />
                <br />
                ※생산 네트워크
                <br />
                1) 직경영 : 미국 1개, 베트남 1개, 방글라데시 2개, 스리랑카 1개
                <br />
                2) 위탁경영 : 미국 1개
                <br />
                <br />
                ※판매 네트워크 : 미국 2개, 캐나다 1개, 호주 1개, 한국 2개
              </div>
              <div className="eng">
                <h2>Founded YoungAn Hat : 1959</h2>
                <br />
                ※ Headquarters : YoungAn Hat Co., Ltd. / YoungAn International Co., Ltd.
                <br />
                ※ The holding&parent company of YoungAn Hat&Apparel business
                <br />
                ※ Taking the headquarter role of managing and coordinating<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;of hat businesses around the world
                <br />
                ※ Global manufacturing & Sales network : 7 countries / 12 affiliates
                <br />
                <br />
                ※ Manufacturing network
                <br />
                1) Direct management : U.S.A, Vietnam, 2 in Bangladesh, Sri Lanka
                <br />
                2) Indirect management : U.S.A
                <br />
                <br />
                ※ Sales network : 2 in U.S.A, Canada, Australia, 2 in Korea
              </div>
              <img src={HatImg} alt="" className="hat-img" />
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default KoreaCompany;
